import { RouterPath } from '../config/global-const'

export interface MenuProfileData {
    profile: any
    currentSalon: any
}

interface MenuSettingItem {
    title: string
    icon: string
    link?: string
    home?: boolean
    children?: Array<any>
    hidden?: boolean // attribute of Nebular
    displayWhenInit?: boolean // default is true
    hiddenCondition?: (data: MenuProfileData) => boolean
}

export const MENU_ITEMS: Array<MenuSettingItem> = [
    {
        title: RouterPath.WORKING.TITLE,
        icon: 'calendar-outline',
        link: RouterPath.WORKING.PATH,
        home: true,
    },
    {
        title: RouterPath.CHECK_IN.TITLE,
        icon: 'edit-2-outline',
        link: RouterPath.CHECK_IN.PATH,
    },
    {
        title: RouterPath.GIFT_CARD.TITLE,
        icon: 'gift-outline',
        link: RouterPath.GIFT_CARD.PATH,
        // children: [
        //     {
        //         title: RouterPath.GIFT_CARD.MANAGE.TITLE,
        //         link: RouterPath.GIFT_CARD.MANAGE.FULL_PATH,
        //         icon: 'radio-button-off-outline',
        //     },
        //     {
        //         title: RouterPath.GIFT_CARD.PRINT_LABEL.TITLE,
        //         link: RouterPath.GIFT_CARD.PRINT_LABEL.FULL_PATH,
        //         icon: 'radio-button-off-outline',
        //     },
        // ],
    },
    {
        title: RouterPath.EMPLOYEES.TITLE,
        icon: 'people-outline',
        link: RouterPath.EMPLOYEES.PATH,
        displayWhenInit: false,
        hiddenCondition: (data) => {
            return data.currentSalon?.SalonUser?.role !== 'owner'
        },
    },
    {
        title: RouterPath.REPORT.TITLE,
        icon: 'file-text-outline',
        link: RouterPath.REPORT.PATH,
        displayWhenInit: false,
        hiddenCondition: (data) => {
            return data.currentSalon?.SalonUser?.role !== 'owner'
        },
    },
    {
        title: RouterPath.SALON_SERVICE.TITLE,
        icon: 'file-text-outline',
        link: RouterPath.SALON_SERVICE.PATH,
        displayWhenInit: false,
        hiddenCondition: (data) => {
            return true // coding
            return data.currentSalon?.SalonUser?.role !== 'owner'
        },
    },
    {
        title: RouterPath.SETTING.TITLE,
        icon: 'layers-outline',
        displayWhenInit: false,
        hiddenCondition: (data) => {
            return data.currentSalon?.SalonUser?.role !== 'owner'
        },
        children: [
            {
                title: RouterPath.SETTING.PRICE_LIST.TITLE,
                link: `${RouterPath.SETTING.PATH}/${RouterPath.SETTING.PRICE_LIST.PATH}`,
                icon: 'radio-button-off-outline',
            },
            {
                title: RouterPath.SETTING.NOTIFICATION.TITLE,
                link: `${RouterPath.SETTING.PATH}/${RouterPath.SETTING.NOTIFICATION.PATH}`,
                icon: 'radio-button-off-outline',
            },
        ],
    },
    {
        title: RouterPath.ADMIN.TITLE,
        icon: 'person-outline',
        displayWhenInit: false,
        hiddenCondition: (data) => {
            return !data.profile?.isRootUser
        },
        children: [
            {
                title: RouterPath.ADMIN.SALON.TITLE,
                icon: 'home-outline',
                link: RouterPath.ADMIN.SALON.FULL_PATH,
            },
            // {
            //     title: RouterPath.PVS_ADMIN.FEEDBACK.TITLE,
            //     icon: 'message-square-outline',
            //     link: RouterPath.PVS_ADMIN.FEEDBACK.FULL_PATH,
            // },
            {
                title: RouterPath.ADMIN.ACCESS.TITLE,
                icon: 'log-in-outline',
                link: RouterPath.ADMIN.ACCESS.FULL_PATH,
            },
            {
                title: RouterPath.ADMIN.USER.TITLE,
                icon: 'people-outline',
                link: RouterPath.ADMIN.USER.FULL_PATH,
            },
            // {
            //     title: RouterPath.PVS_ADMIN.SCHOOL.TITLE,
            //     icon: 'home-outline',
            //     link: RouterPath.PVS_ADMIN.SCHOOL.FULL_PATH,
            // },
            {
                title: RouterPath.ADMIN.VERIFY_CODE.TITLE,
                icon: 'code-outline',
                link: RouterPath.ADMIN.VERIFY_CODE.FULL_PATH,
            },
            // {
            //     title: RouterPath.MOBILE_APP_CONFIG.TITLE,
            //     icon: 'settings-outline',
            //     children: [
            //         {
            //             title: RouterPath.MOBILE_APP_CONFIG.TRANSLATION.TITLE,
            //             link: `${RouterPath.MOBILE_APP_CONFIG.PATH}/${RouterPath.MOBILE_APP_CONFIG.TRANSLATION.PATH}`,
            //             icon: 'radio-button-off-outline',
            //         },
            //     ],
            // },
            // {
            //     title: RouterPath.SERVER_CONFIG.TITLE,
            //     icon: 'settings-outline',
            //     children: [
            //         {
            //             title: RouterPath.SERVER_CONFIG.GENERAL_CONFIG.TITLE,
            //             link: `${RouterPath.SERVER_CONFIG.PATH}/${RouterPath.SERVER_CONFIG.GENERAL_CONFIG.PATH}`,
            //             icon: 'radio-button-off-outline',
            //         },
            //         {
            //             title: RouterPath.SERVER_CONFIG.TRANSLATION.TITLE,
            //             link: `${RouterPath.SERVER_CONFIG.PATH}/${RouterPath.SERVER_CONFIG.TRANSLATION.PATH}`,
            //             icon: 'radio-button-off-outline',
            //         },
            //     ],
            // },
        ],
    },
]
